import { ESubVerticalNames, EVerticalNames } from '@constants';
import { IUser } from '@sdk/contracts';

const getSubVertical = (user: IUser, vertical: EVerticalNames) => {
  if (vertical === EVerticalNames.FP) return undefined;
  if (vertical === EVerticalNames.UNI) {
    if (user.tags.some(tag => tag.name.includes('PCE'))) {
      return ESubVerticalNames.PCE;
    }
    return undefined;
  }
  if (vertical === EVerticalNames.OPOS) {
    if (
      user.tags.some(tag => {
        const normalizedTagName = tag.name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        return /educacion/.test(normalizedTagName);
      })
    ) {
      return ESubVerticalNames.EDU;
    }
    return undefined;
  }
  return undefined;
};

export const useUserVertical = (user: IUser | undefined) => {
  // TODO: adapt this to verticalization
  if (!user) return { userVertical: undefined, userSubVertical: undefined };

  const userVertical: EVerticalNames = user?.tags[0]?.vertical;
  const userSubVertical: ESubVerticalNames | undefined = getSubVertical(user, userVertical);
  return { userVertical, userSubVertical };
};
